import { render } from "./New_BlockUnblockForm.vue?vue&type=template&id=565bce02&scoped=true"
import script from "./New_BlockUnblockForm.vue?vue&type=script&lang=js"
export * from "./New_BlockUnblockForm.vue?vue&type=script&lang=js"

import "./New_BlockUnblockForm.vue?vue&type=style&index=0&id=565bce02&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-565bce02"]])

export default __exports__